/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetShopConfigResponse } from '../models/get-shop-config-response';
@Injectable({
  providedIn: 'root',
})
class ShopConfigCompanyService extends __BaseService {
  static readonly getApiShopConfigCompanyPath = '/api/ShopConfigCompany';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param companyUserEmail undefined
   * @return Success
   */
  getApiShopConfigCompanyResponse(companyUserEmail?: string): __Observable<__StrictHttpResponse<GetShopConfigResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (companyUserEmail != null) __params = __params.set('companyUserEmail', companyUserEmail.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ShopConfigCompany`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetShopConfigResponse>;
      })
    );
  }
  /**
   * @param companyUserEmail undefined
   * @return Success
   */
  getApiShopConfigCompany(companyUserEmail?: string): __Observable<GetShopConfigResponse> {
    return this.getApiShopConfigCompanyResponse(companyUserEmail).pipe(
      __map(_r => _r.body as GetShopConfigResponse)
    );
  }
}

module ShopConfigCompanyService {
}

export { ShopConfigCompanyService }
